import { BatchQueueImpl } from './batch-queue';
import { Hook } from '../hooks-manager';
import { MAX_BATCH_SIZE } from './batch-constants';
export const batchPlugin = function (throttleDuration, options) {
  if (options === void 0) {
    options = {};
  }
  return _ref => {
    let {
      hooksManager,
      globalConfig,
      reporter
    } = _ref;
    if (globalConfig.getReporter()) {
      return;
    }
    const {
      maxBatchSize = MAX_BATCH_SIZE
    } = options;
    globalConfig.initBatchQueue(new BatchQueueImpl({
      throttleDuration,
      maxBatchSize,
      flushHandler: reporter
    }));
    hooksManager.tap(Hook.beforeReport, eventPayload => {
      globalConfig.getBatchQueue().enqueue(eventPayload);
      return false;
    });
  };
};
//# sourceMappingURL=batch-plugin.js.map